import { render, staticRenderFns } from "./EditarPromocao.vue?vue&type=template&id=55a96ddd&"
import script from "./EditarPromocao.vue?vue&type=script&lang=js&"
export * from "./EditarPromocao.vue?vue&type=script&lang=js&"
import style0 from "./EditarPromocao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports